import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import Navbar from "./pages/navbar";
import Accueil from "./pages/Accueil";
import Parole from "./pages/Parole";
import Eucharistie from "./pages/Eucharistie";
import Envoi from "./pages/Envoi";
import { supabase } from "./supabaseClient";
import ScrollToTop from "./assets/components/scrollToTop";
import { Sheet } from "react-modal-sheet";
import COLORS from "./assets/colors";
import { ReactComponent as Close } from "../src/assets/svg/close.svg"; // Import du fichier SVG
import { v4 as uuidv4 } from "uuid";

const App: React.FC = () => {
  const [data, setData] = useState<any>();
  const [active, setActive] = useState<any>();

  const [loading, setLoading] = useState(true);

  const [isOpenSheet, setOpenSheet] = useState(
    (active && active[0]?.modal_sheet) || false
  );
  const closeModal = () => setOpenSheet(false);
  const navbarRef = useRef<{ setPath: (path: string) => void } | null>(null);

  useEffect(() => {
    console.log((active && active[0]?.modal_sheet) || false);
    setOpenSheet((active && active[0]?.modal_sheet) || false);
  }, [active]);

  const [userId, setUserId] = useState(uuidv4());

  useEffect(() => {
    const fetchData = async () => {
      const { data: items, error } = await supabase
        .from("messe")
        .select(
          "*, chantEntree:chantEntree(*), premiereLecture:premiereLecture(*), prierePenitentielle:prierePenitentielle(*), kyrie:kyrie(*), psaume:psaume(*), deuxiemeLecture:deuxiemeLecture(*), evangile:evangile(*), credo:credo(*), priereUniverselle:priereUniverselle(*), offertoire:offertoire(*), sanctus:sanctus(*), notrePere:notrePere(*) , agnusDei:agnusDei(*) ,communion:communion(*), sortie:sortie(*), annonces:annonces(*)"
        )
        .eq("id", "1")
        .single();

      if (error) {
        console.error("Error fetching data:", error);
      } else {
        setData(items);
      }
      const { data: items2, error: error2 } = await supabase
        .from("currentmoment")
        .select("*");
      if (error2) {
        console.error("Error fetching data:", error2);
      } else {
        console.log(items2);
        setActive(items2);
        let path;
        switch (items2[0].temps) {
          case "accueil":
            path = "/";
            break;
          case "parole":
            path = "/parole";
            break;
          case "eucharistie":
            path = "/eucharistie";
            break;
          case "envoi":
            path = "/envoi";
            break;
          default:
            path = "/";
        }
        console.log("path: ", path);
        navbarRef?.current?.setPath(path);
      }

      setLoading(false);
    };

    fetchData();

    // Écouter les changements en temps réel sur la table "messe"
    const channel = supabase.channel("messe");

    channel
      .on(
        "postgres_changes",
        {
          event: "UPDATE",
          schema: "public",
          table: "messe",
          filter: `id=eq.1`,
        },
        fetchData
      )
      .on(
        "postgres_changes",
        {
          event: "UPDATE",
          schema: "public",
          table: "chant",
        },
        fetchData
      )
      .on(
        "postgres_changes",
        {
          event: "UPDATE",
          schema: "public",
          table: "texte",
        },
        fetchData
      )
      .on(
        "postgres_changes",
        {
          event: "UPDATE",
          schema: "public",
          table: "currentmoment",
        },
        fetchData
      )

      .subscribe();

    // Nettoyer l'abonnement à la fin
    // Abonnement à un nouveau channel pour les connexions
    const connectionChannel = supabase.channel("connections");

    connectionChannel.on("broadcast", { event: "HelloThere" }, (payload) => {
      console.log("Received HelloThere message:", payload);
      connectionChannel.send({
        type: "broadcast",
        event: "connected",
        payload: { userId, userAgent: navigator.userAgent },
      });
      const saveUserAgent = async () => {
        const { error } = await supabase
          .from("user_agents")
          .insert([{ userId, userAgent: navigator.userAgent }]);

        if (error) {
          console.error("Error saving user agent:", error);
        } else {
          console.log("User agent saved successfully");
        }
      };

      saveUserAgent();
    });

    // S'abonner au channel
    connectionChannel.subscribe();

    // Nettoyer l'abonnement à la fin
    return () => {
      supabase.removeChannel(channel);
      supabase.removeChannel(connectionChannel);
    };
  }, []);

  useEffect(() => {
    console.log(data);
  }, [data]);
  if (loading) return <div>Loading...</div>;

  return (
    <Router>
      <div>
        <Navbar ref={navbarRef} />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Accueil messe={data} active={active} />} />
          <Route
            path="/parole"
            element={<Parole messe={data} active={active} />}
          />
          <Route
            path="/eucharistie"
            element={<Eucharistie messe={data} active={active} />}
          />
          <Route
            path="/envoi"
            element={<Envoi messe={data} active={active} />}
          />
        </Routes>
        <Sheet
          isOpen={isOpenSheet}
          onClose={() => closeModal()}
          // disableDrag={/^((?!chrome|android).)*safari/i.test(
          //   navigator.userAgent
          // )}
          snapPoints={[600]}
          disableDrag={/^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          )}
        >
          <Sheet.Container
            style={{
              width: "97vw",
              margin: "auto",
              left: "50%",
              translateX: "-50%",
              borderRadius: "30px 30px 0 0",
              overflow: "hidden",
              background: COLORS.background,
            }}
          >
            <Sheet.Header />
            <button
              className="close-button"
              onClick={closeModal}
              style={{
                width: "50px",
                height: "50px",
                zIndex: 100,
                borderRadius: "50%",
                position: "absolute",
                top: "20px",
                right: "20px",
                border: "none",
                background: COLORS.navbar,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Close width="24" height="24" fill="#ffffff" />
            </button>
            <Sheet.Content>
              <Sheet.Scroller draggableAt="both">
                <div
                  style={{ padding: 30, paddingTop: 0, textAlign: "center" }}
                  className="more"
                >
                  {/* <h1>Bonjour !</h1>
                  <h3>
                    Vous êtes en avance !
                    <br />
                    Vous souhaitez écouter les chants pour les apprendre ?
                  </h3>
                  <br />
                  <h3>Chant d'entrée</h3>
                  <a
                    href="https://www.youtube.com/watch?v=uMHOPVs5eTI"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Préparez à travers le désert
                  </a>
                  <br />
                  <br />
                  <h3>Prière universelle</h3>
                  <a
                    href="https://www.youtube.com/watch?v=p2U_BQdrb6w&list=PLj-qqeSVBHUai6cpPg4lEINv5SdGsat_C&index=49"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Fiez vous en Lui
                  </a>
                  <br />
                  <br />
                  <h3>Offertoire</h3>
                  <a
                    href="https://www.youtube.com/watch?v=DEhEzyMHejs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Jésus le Christ
                  </a>
                  <br />
                  <br />
                  <h3>Communion</h3>
                  <a
                    href="https://www.youtube.com/watch?v=ZQ75_-EJ-Jw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Recevez le Christ
                  </a>
                  <br />
                  <br />
                  <h3>Envoi</h3>
                  <a
                    href="https://www.youtube.com/watch?v=puSyyXv7-QU"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Le Seigneur est ma lumière et mon salut
                  </a>
                  <br />
                  <br />
                  <br />
                  <h3>
                    Vous êtes musicien ? <br />
                    <a
                      href="https://drive.proton.me/urls/04HQ85SG00#uOS0vUTT2fAc"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Voici les partitions !
                    </a>{" "}
                  </h3> */}
                  <h1>Bonjour !</h1>
                  <h3>
                    Chaque semaine du Carême, nous vous proposons un sujet de
                    réflexion.
                    <br />
                  </h3>
                  {/* <p style={{ fontSize: "18px", textAlign: "left" }}>
                    Le psaume de ce premier dimanche nous dit&nbsp;: <br />
                    <em>
                      «&nbsp;Sois avec moi Seigneur, dans mon épreuve&nbsp;»
                    </em>
                    .
                    <br />
                    <br />
                    Cette semaine, nous vous invitons à réfléchir à la question
                    suivante&nbsp;: <br />
                    <br />
                    Dans les difficultés, quelles sont les fondations sur
                    lesquelles je peux me reposer, placer mon espérance et
                    dire&nbsp;: <br />
                    <strong>
                      {" "}
                      « Mon refuge, mon rempart, mon Dieu dont je suis sûr » ?
                    </strong>
                  </p> */}

                  {/* <p>
                    Dans la deuxième Lecture, Saint Paul nous dit&nbsp;:
                    <br />
                    <em>
                      «&nbsp;Il n’a pas tenu compte des fautes, et il a déposé
                      en nous la parole de la réconciliation.
                      <br />
                      [...] laissez-vous réconcilier avec Dieu.&nbsp;»
                      <br />
                      <br />
                    </em>
                  </p>
                  <p>
                    Cette semaine, nous vous invitons à réfléchir à la question
                    suivante&nbsp;:
                    <br />
                    <br />
                    <strong>
                      En ce temps de Carême, quelles sont les fautes que je peux
                      pardonner aux autres, mais aussi à moi-même afin de
                      laisser de la place dans mon cœur pour accueillir le
                      mystère de Pâques&nbsp;?
                    </strong>
                  </p> */}
                  <p>
                    Dans la première lecture, Isaïe nous dit&nbsp;:
                    <br />
                    <br />
                    <em>
                      «&nbsp;Oui, je vais faire passer un chemin dans le désert,
                      des fleuves dans les lieux arides [...] pour désaltérer
                      mon peuple.&nbsp;»
                    </em>
                  </p>
                  <p>
                    <strong>
                      En ce temps de Carême, quelles personnes, quelles
                      situations ou quels projets puis-je remettre entre les
                      mains du Seigneur aujourd'hui&nbsp;?
                    </strong>
                  </p>
                  {/* <p>
                    Nous avons tous tendance à accepter le plan de Dieu lorsque
                    celui-ci correspond à nos plans personnels. <br />
                    Cette semaine, nous vous invitons à réfléchir à la question
                    suivante&nbsp;: <br />
                    <br />
                    <strong>
                      Comment puis-je répondre, comme Moïse, «&nbsp;Me
                      voici&nbsp;!&nbsp;» en ayant pleinement foi, confiance et
                      espérance dans les plans du Seigneur&nbsp;?
                    </strong>
                  </p>
                  <p>
                    <br />
                    <em>
                      «&nbsp;Car moi, je connais les pensées que je forme à
                      votre sujet […], pensées de paix et non de malheur, pour
                      vous donner un avenir et une espérance.&nbsp;»
                    </em>
                    <br />
                    Jérémie 29:11
                  </p> */}

                  {/* <h3 style={{ marginBottom: 0 }}>
                    Semons des signes d’espérance
                  </h3>
                  <p
                    style={{
                      fontSize: "16px",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    <br />
                    «&nbsp;Tout le monde espère : L’espérance est contenue dans
                    le coeur de chaque personne comme un désir et une attente du
                    bien, tout en ne sachant pas de quoi demain sera
                    fait.&nbsp;»
                    <br />
                    «&nbsp;Quelque soit le genre de vie, on ne peut pas vivre
                    sans ces trois inclinations de l’âme : croire, espérer et
                    aimer.&nbsp;»
                    <br />
                    Pape François,{" "}
                    <em>«&nbsp;L’espérance ne déçoit pas&nbsp;»</em>
                  </p> */}
                </div>
              </Sheet.Scroller>
            </Sheet.Content>
          </Sheet.Container>
          <Sheet.Backdrop
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(10px)",
            }}
          />
        </Sheet>
      </div>
    </Router>
  );
};

export default App;
